<template>
  <v-container fluid style="height: 100%;">
    <v-row justify="center" style="height: 85%;">
      <v-card
        tile
        style="border-radius: 25px 25px 0 0;"
        width="500px"
      >
        <v-container
          class="fluid"
          :style="bcgColor"
          style="height: 20%; width: 100%;"
        >
        </v-container>
        <v-container
          class="fluid pr-2 pl-6"
          :style="bdyColor"
          style="height: 80%; width: 100%;"
          id="modalContainer"
        >
          <v-row
            style="height: 20%; width: 102.5%;"
            align="center"
            justify="center"
          >
            <span :style="titleProps">{{ titleText }}</span>
          </v-row>
          <v-row
            style="height: 30%; width: 102.5%;"
            align="center"
            justify="center"
          >
            <v-col>
              <p :style="msgProps">{{ msgText }}</p>
            </v-col>
          </v-row>
          <v-row style="height: 5%; width:10%"> </v-row>
          <v-row
            style="height: 20%; width: 100%; padding-left:20%"
            align="center"
            justify="center"
          >
            <component v-bind:is="currentTabComponent"></component>
          </v-row>
          <v-row style="height: 5%; width:10%"> </v-row>
          <v-row
            style="height: 20%; width: 102.5%;"
            align="center"
            justify="center"
          >
            <a :style="cancelProps" @click="cancelClick">{{ cancelText }}</a>
          </v-row>
        </v-container>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import SendToMessenger from "./SendToMessenger.vue";
import DummyDiv from "./DummyDiv.vue";

export default {
  name: "WidgetView",
  components: { SendToMessenger, DummyDiv },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    ...mapGetters(["getWidgetsState", "getFbDetails"]),

    getFbKey() {
      return this.$store.getters.getFbKey;
    },

    currentTabComponent() {
      if (this.getFbDetails.div_class == "fb-send-to-messenger") {
        return "SendToMessenger";
      } else {
        return "DummyDiv";
      }
    },
    detectChange() {
      return this.getWidgetsState.changesSaved;
    },
    bcgColor() {
      let hdrClsObj = {
        "background-color": this.getWidgetsState.header_background_color,
      };
      return hdrClsObj;
    },
    bdyColor() {
      let bdyClsObj = {
        "background-color": this.getWidgetsState.popup_background_color,
      };
      return bdyClsObj;
    },
    titleText() {
      return this.getWidgetsState.pop_up_title;
    },
    titleProps() {
      let ttlObj = {
        color: this.getWidgetsState.pop_up_title_font_color,
        "font-weight": this.getWidgetsState.pop_up_title_font_type,
        "font-size": this.getWidgetsState.pop_up_title_font_size + "px",
        "font-family": this.getWidgetsState.pop_up_title_font_family,
      };
      return ttlObj;
    },
    msgText() {
      return this.getWidgetsState.pop_up_message;
    },
    msgProps() {
      let ttlObj = {
        color: this.getWidgetsState.pop_up_message_font_color,
        "font-weight": this.getWidgetsState.pop_up_message_font_type,
        "font-size": this.getWidgetsState.pop_up_message_font_size + "px",
        "font-family": this.getWidgetsState.pop_up_message_font_family,
        "text-align": "center",
      };
      return ttlObj;
    },
    cancelText() {
      return this.getWidgetsState.pop_up_cancel;
    },
    cancelProps() {
      let ttlObj = {
        color: this.getWidgetsState.pop_up_cancel_font_color,
        "font-weight": this.getWidgetsState.pop_up_cancel_font_type,
        "font-size": this.getWidgetsState.pop_up_cancel_font_size + "px",
        "font-family": this.getWidgetsState.pop_up_cancel_font_family,
        "text-decoration": "underline",
        "text-align": "center",
      };
      return ttlObj;
    },
    widgetType() {
      return this.getWidgetsState.facebook_widget_type;
    },
  },
  methods: {
    fbSubscribe() {},
    cancelClick() {
      this.$store.dispatch("toggleDisplay");
    },
  },
};
</script>

<style scoped>
.fb-btn {
  border-radius: 7px;
  text-transform: none;
}
</style>
